import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TextContent from '@/components/TextContent.vue'
import { useLeaveStore } from '@/stores/leave'
import { translate } from '@/helpers/translate'
import WorkdaySelector from '@/components/WorkdaySelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const leaveStore = useLeaveStore()
const { t } = translate()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createVNode(TextContent, null, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('settingsTitle')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.item)
    }, [
      _createElementVNode("label", {
        class: _normalizeClass(_ctx.$style.label)
      }, _toDisplayString(_unref(t)('setDueDate')), 3),
      _createElementVNode("input", {
        type: "date",
        onChange: _cache[0] || (_cache[0] = event => _unref(leaveStore).setDueDate(new Date(event.currentTarget.value)))
      }, null, 32)
    ], 2),
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.list)
    }, [
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(_ctx.$style.label)
        }, _toDisplayString(_unref(t)('settingsWorkDaysMom')), 3),
        _createVNode(WorkdaySelector, {
          active: _unref(leaveStore).personal.workDaysMom,
          onChange: _cache[1] || (_cache[1] = days => _unref(leaveStore).setWorkDays(true, days))
        }, null, 8, ["active"])
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(_ctx.$style.label)
        }, _toDisplayString(_unref(t)('settingsWorkDaysPartner')), 3),
        _createVNode(WorkdaySelector, {
          active: _unref(leaveStore).personal.workDaysPartner,
          onChange: _cache[2] || (_cache[2] = days => _unref(leaveStore).setWorkDays(false, days))
        }, null, 8, ["active"])
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(_ctx.$style.label)
        }, _toDisplayString(_unref(t)('settingsGrossYearlySalaryMom')), 3),
        _createElementVNode("input", {
          class: _normalizeClass(_ctx.$style.salaryInput),
          type: "number",
          onKeyup: _cache[3] || (_cache[3] = event => _unref(leaveStore).setGrossYearlySalary(parseInt(event.currentTarget.value), true))
        }, null, 34)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(_ctx.$style.label)
        }, _toDisplayString(_unref(t)('settingsGrossYearlySalaryPartner')), 3),
        _createElementVNode("input", {
          class: _normalizeClass(_ctx.$style.salaryInput),
          type: "number",
          onKeyup: _cache[4] || (_cache[4] = event => _unref(leaveStore).setGrossYearlySalary(parseInt(event.currentTarget.value), false))
        }, null, 34)
      ], 2)
    ], 2)
  ], 2))
}
}

})